var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2261 2.25C6.84607 2.25 2.47607 6.62 2.47607 12C2.47607 17.38 6.84607 21.75 12.2261 21.75C17.6061 21.75 21.9761 17.38 21.9761 12C21.9761 6.62 17.6061 2.25 12.2261 2.25ZM12.2261 20.25C7.67607 20.25 3.97607 16.55 3.97607 12C3.97607 7.45 7.67607 3.75 12.2261 3.75C16.7761 3.75 20.4761 7.45 20.4761 12C20.4761 16.55 16.7761 20.25 12.2261 20.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.756 8.46994C15.466 8.17994 14.986 8.17994 14.696 8.46994L12.226 10.9399L9.75602 8.46994C9.46602 8.17994 8.98602 8.17994 8.69602 8.46994C8.40602 8.75994 8.40602 9.23994 8.69602 9.52994L11.166 11.9999L8.69602 14.4699C8.40602 14.7599 8.40602 15.2399 8.69602 15.5299C8.84602 15.6799 9.03602 15.7499 9.22602 15.7499C9.41602 15.7499 9.60602 15.6799 9.75602 15.5299L12.226 13.0599L14.696 15.5299C14.846 15.6799 15.036 15.7499 15.226 15.7499C15.416 15.7499 15.606 15.6799 15.756 15.5299C16.046 15.2399 16.046 14.7599 15.756 14.4699L13.286 11.9999L15.756 9.52994C16.046 9.23994 16.046 8.75994 15.756 8.46994Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross_icon.c1516e9dbe341f616053d9d624c72d09.svg";
export { ForwardRef as ReactComponent };